import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button, ButtonType } from '@lean-body/components/atoms';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { routes } from '@lean-body/src/route';
import { useNavigate } from 'react-router-dom';
import { SettingItemKeys } from './setting_menu';
import { dateToYearMonthDayString } from '@lean-body/src/util';
export const PlanChangeSubsection = ({ classObject, me, changePlan, apiClient, accountService, tracker, alertPresenter, }) => {
    const payment = me.payment;
    const currentPlan = payment.currentPlan;
    const [submitting, setSubmitting] = React.useState(false);
    const navigate = useNavigate();
    const planPrefix = changePlan.isCampaignPlan()
        ? '特別'
        : changePlan.isAnnualPlan()
            ? '年間'
            : changePlan.isStandardPlan()
                ? '月額'
                : null;
    const toPerUnit = (p) => {
        if (p.isStandardPlan())
            return ' / 月';
        if (p.isThreeMonthPlan())
            return ' / 3ヶ月';
        if (p.isSixMonthPlan())
            return ' / 6ヶ月';
        if (p.isAnnualPlan())
            return ' / 年';
        return null;
    };
    const onSubmit = () => {
        setSubmitting(true);
        apiClient
            .changePlan({ planId: changePlan.stripePlanId })
            .then(() => {
            accountService.reloadMe();
            tracker.trackClickPlanChange(changePlan, me);
            alertPresenter.showMessage('プラン変更に成功しました');
            navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys.plan}`);
        })
            .catch((e) => {
            alertPresenter.showMessage('プラン変更に失敗しました');
            throw e;
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.head) }, "\u30D7\u30E9\u30F3\u5207\u308A\u66FF\u3048"),
        React.createElement("div", { className: css(styles.title) },
            planPrefix,
            "\u30D7\u30E9\u30F3\u3078\u306E\u5207\u308A\u66FF\u3048"),
        React.createElement("div", { className: css(styles.explanation) },
            "\u6B21\u56DE\u306E\u30D7\u30E9\u30F3\u66F4\u65B0\u65E5\uFF08",
            dateToYearMonthDayString(payment.curPeriodEndDate),
            "\uFF09\u304B\u3089",
            planPrefix,
            "\u30D7\u30E9\u30F3\u306B\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u3002"),
        React.createElement("div", { className: css(styles.planLabel) }, "\u73FE\u5728\u306E\u30D7\u30E9\u30F3"),
        React.createElement("div", { className: css(styles.planAmount) },
            currentPlan.amount.toLocaleString(),
            "\u5186(\u7A0E\u8FBC)",
            toPerUnit(currentPlan)),
        React.createElement("div", { className: css(styles.planLabel) }, "\u3054\u63D0\u6848\u306E\u30D7\u30E9\u30F3\uFF1A"),
        React.createElement("div", { className: css(styles.planAmount) },
            changePlan.amount.toLocaleString(),
            "\u5186(\u7A0E\u8FBC)",
            toPerUnit(changePlan),
            changePlan.isCampaignPlan() && (React.createElement("div", { className: css(styles.perMonth) },
                changePlan.amountPerMonth.toLocaleString(),
                "\u5186 / \u6708\u76F8\u5F53"))),
        React.createElement(Button, { className: css(styles.button), buttonType: ButtonType.primary, onClick: onSubmit, loading: submitting, disabled: submitting, dataTest: "submitChangePlan" }, "\u30D7\u30E9\u30F3\u3092\u5207\u308A\u66FF\u3048\u308B")));
};
const styles = StyleSheet.create({
    container: {},
    head: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 24,
        textAlign: 'start',
    },
    title: {
        fontWeight: 'bold',
        marginBottom: 16,
    },
    explanation: {
        fontSize: 13,
        marginBottom: 14,
    },
    planLabel: {
        fontSize: 12,
        marginTop: 40,
    },
    planAmount: {
        fontSize: 14,
        fontWeight: 'bold',
        margin: '5px 0 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    perMonth: {
        padding: 10,
        color: Colors.Accent,
        backgroundColor: Colors.BackgroundLightGray,
        marginLeft: 8,
    },
    button: {
        width: '100%',
        marginTop: 40,
        [MediaBreakPointUp.MD]: {
            maxWidth: 240,
            margin: '40px auto 0',
        },
    },
});
